//@ts-check
import axios from "axios";

//AuthService
export default {
	getClient(clientId) {
		if (!clientId || clientId == "" || clientId == "current") {
			return axios.get(`/v3/client`);
		} else {
			return axios.get(`/v3/client/${clientId}`);
		}
	},

	saveClient(client) {
		return axios.post("/v3/client", client);
	},

	saveCredential(credential) {
		return axios.post("/v3/credential", credential);
	},

	listCredentials(clientID) {
		return axios.get(`/v3/credentials/${clientID}`);
	},

	removeCredential(credID) {
		return axios.delete(`/v3/credential/${credID}`);
	},

	canDeleteRole(roleID) {
		return axios.get(`/v3/role/can_delete/${roleID}`);
	}
};



// WEBPACK FOOTER //
// ./src/services/TenantService.js